import React, { useContext, useEffect, useState } from 'react';
import { AssessmentContext } from '../context/AssessmentContext';
import '../styles/Table.css';

const SectionsTab = ({ assessmentId }) => {
  const {
    assessment,
    deleteSection,
    loading,
    saveSection,
    section,
    selectSection,
  } = useContext(AssessmentContext);

  const [code, setCode] = useState('');
  const [mode, setMode] = useState('list');
  const [name, setName] = useState('');
  const [order, setOrder] = useState(0);

  useEffect(() => {
    setMode('list');
  }, [assessment]);

  const handleCancel = () => {
    setMode('list'); 
  }

  const handleNew = () => {
    setName('');
    setCode('');
    selectSection(null);
    setOrder(assessment.sections.length + 1);
    setMode('edit');
  }

  const handleEditSection = async (sectionId) => {
    selectSection(sectionId);
    setName(section.name);
    setCode(section.code);
    setOrder(section.order);
    setMode('edit');
  }

  const handleSaveSection = async () => {
    section.name = name;
    section.code = code;
    section.order = order;
    await saveSection(section);
  }

  if (loading) {
    return <div>Cargando datos...</div>;
  }

  return (
    <div>
      {mode === 'list' && (
        <>
          <button onClick={() => handleNew() }>
            <span role="img" aria-label="add">➕</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      {mode === 'edit' && (
        <>
          <button onClick={() => handleCancel() }>
            <span role="img" aria-label="cancel">❌</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      {mode === 'list' && (
        <table>
          <thead>
            <tr>
              <th>Orden</th>
              <th>Código</th>
              <th>Nombre</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {assessment.sections.map((section, index) => (
              <tr key={index}>
                <td>{section.order}</td>
                <td>{section.code}</td>
                <td>{section.name}</td>
                <td>
                  <button onClick={() => handleEditSection(section.id)}>
                    <span role="img" aria-label="edit">✏️</span>
                  </button>
                  <button onClick={() => deleteSection(section.id)}>
                    <span role="img" aria-label="delete">🗑️</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {mode === 'edit' && (
        <>
          <div>
            <input
              type="number"
              value={order}
              onChange={(e) => setOrder(e.target.value) }
              placeholder='Orden'
            />
          </div>
          <div>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value) }
              placeholder='Código'
            />
          </div>
          <div>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value) }
              placeholder='Nombre'
            />
          </div>
          <br/>
          <button onClick={() => handleSaveSection() }>
            Grabar
          </button>
        </>
      )}
    </div>
  );
};

export default SectionsTab;
